import { FormEvent } from 'react';
import { Typography, Theme, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5em 0 3.5em',
    '& div:not(:last-child)': {
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
  textFieldContainer: {
    width: '100%',
  },
  continueButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

interface RoomNameScreenProps {
  roomName: string;
  setRoomName: (roomName: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomNameScreen(_: RoomNameScreenProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const handleCancel = () => {
    navigate('/dashboard')
  }

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Welcome to Sessions
      </Typography>
      <div>
        <Button variant="outlined" color="primary"
          onClick={handleCancel}
          style={{
            marginRight: 8,
          }}
        >
          Cancel
        </Button>
      </div>
    </>
  );
}
